/* eslint no-unused-vars: 0 */
import React, { Component } from 'react';
import { Link } from 'react-router';

import Icon from '../icons/Icon';

import { StepOrder, NavigationMap, BarLabelMap } from '../../constants/Steps';

export default class ProgressBarHeader extends Component {

    getProgressBarItems() {
        const barItems = [];

        for (let i = StepOrder.CONTACT; i < StepOrder.FINISH; i++) {
            if (i === StepOrder.FINISH) {
                continue;
            }

            const checkmarkStyle = { fill: 'white' };
            let item = <div className="app__header__progress-item">
                <div className="app__header__progress-circle"></div>
                <div className="app__header__progress-text">{ BarLabelMap[i] }</div>
            </div>;

            if (i <= this.props.stepIndex) {
                item = (
                    <div className="app__header__progress-item">
                        <div className="app__header__progress-circle
                                        app__header__progress-circle--selected">
                            <div className="progress-circle__checkmark">
                                <Icon icon="checkmark" size="25px" style={ checkmarkStyle }/>
                            </div>
                        </div>
                        <div className="app__header__progress-text">{ BarLabelMap[i] }</div>
                    </div>
                );
            }

            barItems.push(item);
        }
        return barItems;
    }

    render() {
        return <div className="app__header__progress">
            { this.getProgressBarItems() }
        </div>;
    }
}

ProgressBarHeader.propTypes = {
    stepIndex: React.PropTypes.number,
};



// WEBPACK FOOTER //
// ./src/components/header/ProgressBarHeader.jsx